//Provide a global abstraction from the implementation details of an api call
import type { BlobApi } from './blob-api';
import type { ClientAgentApi } from './clientagent-api';
import type { ClientApi } from './client-api';
import type { FabricationJobApi } from './fabrication-job-api';
import type { FabricationPurchaseOrderApi } from './fabrication-purchase-order-api';
import type { FranchiseeApi } from './franchisee-api';
import type { FranchiseeClientApi } from './franchisee-client-api';
import type { LangApi } from './lang-api';
import type { PaymentProfileApi } from './payment-profile-api';
import type { ProjectApi } from './project-api';
import type { PurchaseOrderApi } from './purchase-order-api';
import type { QuoteApi } from './quote-api';
import type { SupplierApi } from './supplier-api';
import type { TermsAndConditionsApi } from './terms-and-conditions-api';
import type { UserApi } from './user-api';

export interface ApiFactory {
  blob: () => BlobApi;
  quote: () => QuoteApi;
  client: () => ClientApi;
  project: () => ProjectApi;
  franchisee: () => FranchiseeApi;
  fabricationJob: () => FabricationJobApi;
  fabricationPurchaseOrder: () => FabricationPurchaseOrderApi;
  paymentProfile: () => PaymentProfileApi;
  purchaseOrder: () => PurchaseOrderApi;
  supplier: () => SupplierApi;
  clientAgent: () => ClientAgentApi;
  termsAndConditions: () => TermsAndConditionsApi;
  user: () => UserApi;
  lang: () => LangApi;
  franchiseeClient: () => FranchiseeClientApi;
}

let _apiFactory: ApiFactory = {
  quote: () => {
    throw new Error('please call setApiInjector - quote api not registered');
  },
  blob: () => {
    throw new Error('please call setApiInjector - blob api not registered');
  },
  client: () => {
    throw new Error('please call setApiInjector - client api not registered');
  },
  project: () => {
    throw new Error('please call setApiInjector - project api not registered');
  },
  franchisee: () => {
    throw new Error('please call setApiInjector - franchisee api not registered');
  },
  fabricationJob: () => {
    throw new Error('please call setApiInjector - fabricationJob api not registered');
  },
  fabricationPurchaseOrder: () => {
    throw new Error('please call setApiInjector - fabricationPurchaseOrder api not registered');
  },
  paymentProfile: () => {
    throw new Error('please call setApiInjector - paymentProfile api not registered');
  },
  purchaseOrder: () => {
    throw new Error('please call setApiInjector - purchaseOrder api not registered');
  },
  supplier: () => {
    throw new Error('please call setApiInjector - supplier api not registered');
  },
  clientAgent: () => {
    throw new Error('please call setApiInjector - clientAgent api not registered');
  },
  user: () => {
    throw new Error('please call setApiInjector - user api not registered');
  },
  lang: () => {
    throw new Error('please call setApiInjector - user api not registered');
  },
  termsAndConditions: () => {
    throw new Error('please call setApiInjector - termsAndConditions api not registered');
  },
  franchiseeClient: () => {
    throw new Error('please call setApiInjector - franchiseeClient api not registered');
  }
};

export function setApiFactory(factory: ApiFactory) {
  _apiFactory = factory;
}

export function getApiFactory() {
  return _apiFactory;
}

export * from '../../webmodule-common/other/api/api-injector';
